/**
 * Invoice Hooks
 */

import React from 'react'
import type { Prefix, Invoice, Column, DownloadTemplate, InvoiceAttachment, InvoiceRefundRequest, InvoiceTransaction, InvoiceItem } from '@/types/invoice'
import { Note } from '@/types/customer'

export const fetchEBarimt = async (params?: {
	limit?: number
	page?: number
	search?: string
	type?: 'sent' | 'cancelled' | 'all',
	customerId?: string
	contractId?: string
	startDate?: string
	endDate?: string
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/ebarimt/receipts`)
		params && url.searchParams.append('limit', params.limit?.toString() ?? '10')
		params && url.searchParams.append('page', params.page?.toString() ?? '1')
		params?.search && url.searchParams.append('search', params.search ?? '')
		params?.type && url.searchParams.append('type', params.type)
		params?.customerId && url.searchParams.append('customerId', params.customerId)
		params?.contractId && url.searchParams.append('contractId', params.contractId)
		params?.startDate && url.searchParams.append('startDate', params.startDate)
		params?.endDate && url.searchParams.append('endDate', params.endDate)

		const res = await fetch(url.toString())
		const data = await res.json()

		if(data.success) {
			return {
				receipts: data.data.receipts,
				total: data.data.total,
			}
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error: any) {
		throw new Error(error?.message ?? 'Алдаа гарлаа')
	}
}

export const fetchInvoiceTransaction = async (id: string) => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/transaction/${id}`)
		const data = await res.json()

		if (data.success) {
			return data.data as InvoiceTransaction
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchInvoiceTags = async (params?: {
	limit?: number
	page?: number
	search?: string
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/tags`)
		params && url.searchParams.append('limit', params.limit?.toString() ?? '10')
		params && url.searchParams.append('page', params.page?.toString() ?? '1')
		params?.search && url.searchParams.append('search', params.search ?? '')
		const res = await fetch(url.toString())
		const data = await res.json()

		if (data.success) {
			return data.data as string[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchInvoiceTransactions = async (invoiceId: string) => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/${invoiceId}/transactions`)
		const data = await res.json()

		if (data.success) {
			return data.data as InvoiceTransaction[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const checkEBarimtService = async () => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/ebarimt`)
		const data = await res.json()

		if (data.success) {
			return data.data as { 
				registerNo: string
				posId: string
			}
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error: any) {
		console.error(error)
		throw new Error(error ?? 'Алдаа гарлаа')
	}
}

export const fetchInvoiceAttachments = async (invoiceId: string) => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/${invoiceId}/attachments`)
		const data = await res.json()

		if (data.success) {
			return data.data as InvoiceAttachment[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchRefundRequest = async (id: string) => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/refund/${id}`)
		const data = await res.json()

		if (data.success) {
			return data.data as InvoiceRefundRequest
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchRefundRequests = async (params?: {
	page: number,
	limit: number,
	search?: string,
	status?: 'pending' | 'approved' | 'rejected' | 'all',
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/refund`)
		params && url.searchParams.append('page', params.page.toString())
		params && url.searchParams.append('limit', params.limit.toString())
		params && url.searchParams.append('search', params.search ?? '')
		params && url.searchParams.append('status', params.status ?? 'all')

		const res = await fetch(url.toString())
		const data = await res.json()

		if (data.success) {
			return data.data as {
				refundRequests: InvoiceRefundRequest[]
				total: number
			}
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchInvoiceNotes = async (invoiceId: string, params?: {
	page: number
	limit: number
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/${invoiceId}/notes`);
		params && url.searchParams.append('page', params.page.toString())
		params && url.searchParams.append('limit', params.limit.toString())
		const res = await fetch(url.toString())
		const data = await res.json()

		if (data.success) {
			return data.data as {
				notes: Note[],
				total: number
			}
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchDownloadTemplateColumns = async () => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/template/columns`)
		const data = await res.json()

		if (data.success) {
			return data.data as Column[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchDownloadTemplates = async () => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/template`)
		const data = await res.json()

		if (data.success) {
			return data.data as DownloadTemplate[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchTemplate = async (id: string) => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/template/${id}`)
		const data = await res.json()

		if (data.success) {
			return data.data as DownloadTemplate
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchPaymentMethods = async () => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/payment-methods`)
		const data = await res.json()

		if (data.success) {
			return data.data as { id: string; name: string; label: string; isDefault: boolean }[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}

}

export const fetchInvoicePrefixes = async () => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/prefix`)
		const data = await res.json()

		if (data.success) {
			return data.data as Prefix[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (e) {
		console.error(e)
		throw new Error('Алдаа гарлаа')
	}
}

type Filter = {
	search?: string
	limit: number
	page: number
	startDate?: Date | string
	endDate?: Date | string
	customerId?: string
	contractId?: string
	exclude?: string[]
	status?: 'paid' | 'pending' | 'draft' | 'cancelled' | 'all' | string & {}
	prefix?: string
	billingType?: string
	paymentMethod?: string
	amount?: 'greater-than-zero' | 'zero' | 'all' | string & {}
	customers?: string[]
	minAmount?: number
	maxAmount?: number
}

export const fetchInvoices = async (filter: Filter) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice`)
		filter.search && url.searchParams.append('search', filter.search)
		filter.limit ? url.searchParams.append('limit', filter.limit.toString()) : url.searchParams.append('limit', '10')
		filter.page ? url.searchParams.append('page', (filter.page + 1).toString()) : url.searchParams.append('page', '1')
		filter.startDate && url.searchParams.append('startDate', new Date(filter.startDate).toISOString())
		filter.endDate && url.searchParams.append('endDate', new Date(filter.endDate).toISOString())
		filter.customerId && url.searchParams.append('customerId', filter.customerId)
		filter.contractId && url.searchParams.append('contractId', filter.contractId)
		filter.exclude && url.searchParams.append('exclude', filter.exclude.join(','))
		filter.status && filter.status.length > 0 && url.searchParams.append('status', String(filter.status))
		filter.prefix && url.searchParams.append('prefix', filter.prefix)
		filter.billingType && url.searchParams.append('billingType', filter.billingType)
		filter.paymentMethod && url.searchParams.append('paymentMethod', filter.paymentMethod)
		filter.amount && url.searchParams.append('amount', filter.amount)
		filter.customers && filter.customers.length > 0 && url.searchParams.append('customers', filter.customers.join(','))
		filter.minAmount && url.searchParams.append('minAmount', filter.minAmount.toString())
		filter.maxAmount && url.searchParams.append('maxAmount', filter.maxAmount.toString())

		const res = await fetch(url.toString())

		const data = await res.json()

		if (data.success) {
			return {
				invoices: data.data.invoices,
				total: data.data.total,
			} as {
				invoices: Invoice[]
				total: number
			}
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (e) {
		console.error(e)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchContractUsageItems = async (contractId: string, params?: {
	cycleId?: string
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/usage/contract/${contractId}`)
		
		if (params?.cycleId) {
			url.searchParams.append('cycleId', params.cycleId)
		}

		const res = await fetch(url.toString())
		const data = await res.json()

		if (data.success) {
			return data.data as InvoiceItem[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchInvoice = async (id: string) => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/${id}`)
		const data = await res.json()

		if (data.success) {
			return data.data as Invoice
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (e) {
		console.error(e)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchBillingTypes = async () => {
	try {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/invoice/billingTypes`)
		const data = await res.json()

		if (data.success) {
			return data.data as { id: string; name: string; label: string; isDefault: boolean }[]
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchInvoiceCount = async (params: {
	period?: 'day' | 'week' | 'month' | 'year'
	status?: 'paid' | 'pending' | 'cancelled' | 'refunded' | 'failed' | 'expired' | 'processing' | 'all'
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/count`)
		params.period && url.searchParams.append('period', params.period)

		const res = await fetch(url.toString())
		const data = await res.json()

		if (data.success) {
			return data.data as { date: string; count: number }
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}

export const fetchRevenue = async (params: {
	period?: 'daily' | 'weekly' | 'monthly' | 'yearly'
}) => {
	try {
		const url = new URL(`${process.env.REACT_APP_API_URL}/invoice/revenue`)
		params.period && url.searchParams.append('period', params.period)

		const res = await fetch(url.toString())
		const data = await res.json()

		if (data.success) {
			return data.data as { date: string; revenue: number; isBlurred?: boolean }
		} else {
			throw new Error(data.message ?? 'Алдаа гарлаа')
		}
	} catch (error) {
		console.error(error)
		throw new Error('Алдаа гарлаа')
	}
}